module.exports = __webpack_public_path__ + "img/31.0acd3ead.png";